<script setup lang="ts"></script>

<template>
  <span class="flex flex-col text-purple-gray text-base md:text-[20px] leading-6 tracking-[-0.6px]">
    Smash <span class="text-lavender contents">Asteroids</span> with your Power Miles! Each smash gives you one of <span class="text-lavender contents">5 rare Elements</span> and a free raffle ticket.
    <span>Collect all five to unlock Element 6 and win big! 🚀🔥</span>
  </span>
</template>

<style scoped></style>
